/**
 * Nuur Mobile — house brand (orange).
 *
 * Values lifted verbatim from the former `NUUR_DEFAULT_BRANDING` constant in
 * `BrandingProvider.tsx` and the previously-hardcoded `index.html` <head>.
 * This is the DEFAULT brand when no `VITE_BRAND` is selected.
 */
import type { BrandConfig } from '../types';

const nuur: BrandConfig = {
  key: 'nuur',
  // NUUR_TENANT_ID — services/shared/shared/tenants.py. Keep in lockstep.
  tenantId: '019e89d9-1453-7d42-a086-dae87e60f461',
  // Seeded by platform-service migration 0021 — the dev-only resolve fallback.
  devHost: 'nuurmobiledev.com',
  branding: {
    displayName: 'Nuur Mobile',
    // Horizontal wordmark (name baked in) → rendered on its own. Vector, and
    // shipped in two inks: the wordmark bakes its own text colour, so the
    // ink-on-light version is illegible against the dark sidebar.
    logoLightUrl: '/brands/nuur/logo.svg',
    logoDarkUrl: '/brands/nuur/logo-dark.svg',
    logoType: 'wordmark',
    faviconUrl: '/brands/nuur/mark.svg',
    colorTokens: {
      // Full 50→700 brand ramp — orange, pixel-sampled from mark.png.
      brand50: '#FFF1E6',
      brand100: '#FFE0CC',
      brand200: '#FFC299',
      brand300: '#FFA366',
      brand400: '#FB8636',
      brand500: '#F87018',
      brand600: '#E0650F',
      brand700: '#C75A0E',
      // Legacy three-key contract, kept aligned with the ramp.
      primary: '#F87018',
      secondary: '#E0650F',
      accent: '#FB8636',
    },
    fontFamily:
      "Manrope, ui-sans-serif, -apple-system, 'Segoe UI', Roboto, sans-serif",
    customCss: null,
    supportPhone: null,
    supportEmail: 'support@nuurmobile.com',
    termsUrl: null,
  },
  html: {
    title: 'Nuur Mobile · Admin',
    description:
      'Nuur Mobile Admin — Manage device financing plans, customers, payments, KYC reviews, and operations.',
    themeColor: '#F87018',
    faviconHref: '/brands/nuur/mark.svg',
    // Apple touch icons must be raster — iOS ignores SVG here.
    appleTouchIconHref: '/brands/nuur/mark.png',
  },
};

export default nuur;
